import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';

import type { Grid, GridSearchItem } from '../../../../shared/Models/grid';
import { TextColumn } from '../../../../shared/Models/columns';
import { Helper } from '../../../../helpers/helper.service';
import { ExchangeService } from '../../../Services/exchange.service';

const EMPTY_VALUE = '—';
const PLACEHOLDER = '-';

@Component({
  selector: 'app-exchange-logs-overview',
  templateUrl: './exchange-logs-overview.component.html',
  styleUrls: ['./exchange-logs-overview.component.scss'],
})
export class ExchangeLogsOverviewComponent implements OnInit {
  public grid: Grid;
  @ViewChild('cellEllipsisTooltip', { static: true }) cellEllipsisTooltip!: TemplateRef<unknown>;

  @ViewChild('exchangeLogRowDetail', { static: true }) exchangeLogRowDetail!: TemplateRef<unknown>;

  constructor(
    private router: Router,
    public helper: Helper,
    private exchangeService: ExchangeService,
  ) {}

  detailText(value: unknown): string {
    return this.isEmpty(value) ? EMPTY_VALUE : this.stringify(value);
  }

  private stringify(value: unknown, fallback: string = EMPTY_VALUE): string {
    if (typeof value === 'string') {
      return value;
    }
    if (typeof value === 'number') {
      return value.toString();
    }
    return fallback;
  }

  private isEmpty(value: unknown): boolean {
    return value === null || value === undefined || value === '';
  }

  cellDisplay(column: TextColumn, value: unknown): { text: string; showTooltip: boolean } {
    const raw = column?.valueFormatter ? column.valueFormatter(value as never) : value;
    const text = this.isEmpty(raw) ? PLACEHOLDER : this.stringify(raw, PLACEHOLDER);

    const trimmed = text.trim();
    const showTooltip = trimmed.length > 0 && trimmed !== PLACEHOLDER && trimmed !== EMPTY_VALUE;
    return { text, showTooltip };
  }

  ngOnInit() {
    const dateFormat = 'YYYY-MM-DD hh:mm';

    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.exchange_log.changedAt',
          prop: 'changedAt',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          maxWidth: 200,
          noTruncate: true,
          valueTemplate: this.cellEllipsisTooltip,
          valueFormatter: row => moment(row).format(dateFormat),
        },
        <TextColumn>{
          name: 'doctrine.exchange_log.serviceNumber',
          prop: 'orderExchange.serviceNumber',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          maxWidth: 320,
          noTruncate: true,
          valueTemplate: this.cellEllipsisTooltip,
        },
        <TextColumn>{
          name: 'doctrine.exchange_log.orderNo',
          prop: 'orderExchange.order.orderNo',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          noTruncate: true,
          valueTemplate: this.cellEllipsisTooltip,
        },
        <TextColumn>{
          name: 'doctrine.exchange_log.newValue',
          prop: 'newValue',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          noTruncate: true,
          valueTemplate: this.cellEllipsisTooltip,
        },
        <TextColumn>{
          name: 'doctrine.exchange_log.oldValue',
          prop: 'oldValue',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          noTruncate: true,
          valueTemplate: this.cellEllipsisTooltip,
        },
        <TextColumn>{
          name: 'doctrine.exchange_log.changedBy',
          prop: 'changedBy.fullName',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          noTruncate: true,
          valueTemplate: this.cellEllipsisTooltip,
          valueFormatter: value => this.detailText(value),
        },
        <TextColumn>{
          name: 'doctrine.exchange_log.message',
          prop: 'message',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          noTruncate: true,
          minWidth: 320,
          width: 350,
          valueTemplate: this.cellEllipsisTooltip,
        },
      ],
      service: this.exchangeService,
      rememberURL: this.router.url,
      method: 'getExchangeLogs',
      searchPlaceholder: 'search.about.order.no',
      defaultSort: 'createdAt',
      rowDetailTemplate: this.exchangeLogRowDetail,
      rowDetailShowCallback: (_row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
            doseNotHaveSearch: true,
            multipleRowSearch: false,
            search: [
              <GridSearchItem>{
                hasCalendar: false,
                hasDropdownListFilter: false,
                hasStatus: false,
                hasNormalSearch: true,
                order: [
                  {actionOrder: 1, datepickerOrder: 2, normalSearchOrder: 3}
                ],
              }
            ],
    };
  }

}

